var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tips"},[_vm._v("使用window.print()实现pdf下载")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.printPdf}},[_vm._v("点击下载pdf")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }